import React, { useEffect, useState } from 'react';
import { CAN_SELECT_STATUS, IDepartmentSearchPathInfo, IMemberInfo } from '../../interface';
import { components } from 'common';
import { defaultPageInfo } from '../../service/defaultData/knowledgePoint';
import { lang } from '@umu/ukit-lang';
import { Checkbox, Iconfont } from '@umu/umu-design';
import { MEMBER_TYPE, SWITCH_STATUS } from '../../interface';
import { $document, classSet } from '@umu/umu-dom';
import { COLOR_MAP } from '../../utils';
import { IPageInfo } from '@umu/umu-types';
import { UserAvatar } from '../../../user';
import { getAvatarWord } from '../../../@loadAvatar/loadAvatar';
import InfiniteScroll from '../../../@infiniteScroll/infiniteScroll';
import ListBlankM from '../../../ListBlank/ListBlankM';
import './index.scss';
import { RadioBox } from '../radio';

interface IProps {
    pageInfo?: IPageInfo;
    list: IMemberInfo[];
    path: IDepartmentSearchPathInfo[];
    selectList?: IMemberInfo[];
    getListByPage?: (page: number, onSuccessCallback: VoidFunction) => void;
    onSelectNext: (id: string) => void;
    onSelectItem: (checked: boolean, item: IMemberInfo) => void;
    children?: React.ReactNode;
    isMultiple?: boolean;
}
const { List, ListLoading, If } = components;

function MemberList(props: IProps) {
    const {
        list,
        pageInfo = defaultPageInfo,
        selectList = [],
        path = [],
        children,
        getListByPage,
        onSelectNext,
        onSelectItem,
        isMultiple = true,
    } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [scroll, setScroll] = useState<Element | undefined>(undefined);
    const onLoadMore = async () => {
        if (pageInfo.total_page_num <= pageInfo.current_page || isLoading) {
            return;
        }
        setIsLoading(true);
        getListByPage &&
            getListByPage(pageInfo.current_page + 1, () => {
                setIsLoading(false);
            });
    };
    useEffect(() => {
        const scrollEl = $document.querySelector('.comment-search-index-page') || undefined;
        setScroll(scrollEl);
    }, []);
    const onItemCheck = (checked: boolean, item: IMemberInfo) => {
        onSelectItem &&
            onSelectItem(checked, {
                ...item,
                path,
            });
    };
    const renderListItem = (item: IMemberInfo, index: number) => {
        const isDepartment = item.type === MEMBER_TYPE.DEPARTMENT;
        const isCheck = selectList.some((selectItem) => selectItem.id === item.id);
        const label = item.name || item.login_name || item.email || item.phone;
        const isDepartmentManage = Number(item.is_department_manager) === SWITCH_STATUS.YES;
        let isNotAllowCheck = false;
        if (Object(item).hasOwnProperty('can_select') && item.can_select === CAN_SELECT_STATUS.NO) {
            isNotAllowCheck = true;
        } else if (Object(item).hasOwnProperty('is_manage') && item.is_manage === SWITCH_STATUS.NO) {
            isNotAllowCheck = true;
        }

        const hasChild = () => {
            if (Object(item).hasOwnProperty('has_child')) {
                return item.has_child === SWITCH_STATUS.YES;
            }
            return true;
        };
        return (
            <div
                key={`member-item-${item.id}`}
                className={classSet({
                    'member-search-result-item': true,
                    'member-search-result-item-no-event': isNotAllowCheck,
                })}
                onClick={() => !isNotAllowCheck && onItemCheck(!isCheck, item)}
            >
                <If condition={isMultiple}>
                    <Checkbox checked={isCheck} disabled={isNotAllowCheck} className="member-split-col" />
                </If>
                <If condition={!isMultiple}>
                    <RadioBox checked={isCheck} disabled={isNotAllowCheck} />
                </If>

                <If condition={!isDepartment}>
                    {item.avatar ? (
                        <UserAvatar className="avatar-component member-split-col" src={item.avatar || ''} width={23} />
                    ) : (
                        <div
                            className="department-search-avatar-label member-split-col"
                            style={{ backgroundColor: COLOR_MAP[Number(item.id || index) % COLOR_MAP.length] }}
                        >
                            {getAvatarWord(label)}
                        </div>
                    )}
                </If>
                <div className="member-item-label">
                    <span className="item-info-label">{label}</span>
                    <If condition={isDepartmentManage && !isDepartment}>
                        <span className="manage-department-label">{lang('负责人')}</span>
                    </If>
                    <If condition={isDepartment}>
                        <span className="static-count">{` (${item.user_num})`}</span>
                    </If>
                </div>
                <If condition={isDepartment && hasChild()}>
                    <Iconfont
                        type="SmallMore"
                        className="icon-item-more"
                        onClick={(e) => {
                            e.stopPropagation && e.stopPropagation();
                            onSelectNext(item.id);
                        }}
                    />
                </If>
            </div>
        );
    };
    const renderContent = () => {
        if (list.length <= 0) {
            return <ListBlankM title={lang('暂无组织结构')} type={2} />;
        }
        return (
            <List
                dataList={list}
                className="member-search-result-list-info"
                totalPageNum={1}
                currentPage={1}
                renderItem={renderListItem}
            />
        );
    };
    return (
        <InfiniteScroll
            load={onLoadMore}
            hasMore={pageInfo.total_page_num > pageInfo.current_page}
            isLoading={isLoading}
            bottomDistance={70}
            scrollThreshold={500}
            viewportSelector={scroll}
            scrollerSelector={scroll}
        >
            {renderContent()}
            <If condition={isLoading || (!isLoading && pageInfo.total_page_num > 1)}>
                <div className="infinite-scroll-expand-info">
                    {isLoading && <ListLoading />}
                    {!isLoading && children}
                </div>
            </If>
        </InfiniteScroll>
    );
}

export default MemberList;
